<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="TITLE"><a id="_idTOCAnchor-1"></a>Called to the Life of the Mind</p>
<p class="SUBTITLE">Some Advice for Evangelical Scholars</p>
<p class="AUTHOR">Richard J. Mouw</p>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenPageitem-2">
<img alt="" class="_idGenPageitem-1" src="image/COMPASS.jpg"/>
</div>
</div>
<div>
<p class="COMPANY"><span class="sc">William B. Eerdmans Publishing Company<br/></span>Grand Rapids, Michigan / Cambridge, U.K.</p>
<p class="COPYRIGHT">© 2014 Richard J. Mouw<br/>All rights reserved<br/><br/>Published 2014 by<br/><span class="sc">Wm. B. Eerdmans Publishing Co.<br/></span>2140 Oak Industrial Drive <span class="sc">n.e.,</span> Grand Rapids, Michigan 49505 /<br/><span class="sc">p.o. </span>Box 163, Cambridge <span class="sc">cb3 9pu</span> U.K.<br/><br/>Printed in the United States of America</p>
<p class="LIBRARY">Library of Congress Cataloging-in-Publication Data</p>
<p class="CIP">Mouw, Richard J.<br/>Called to the life of the mind:<br/>some advice for evangelical scholars / Richard J. Mouw.<br/>pages   cm<br/><span class="sc">isbn</span> 978-0-8028-6766-7 (pbk.: alk. paper)<br/><span class="sc">eisbn</span> 978-1-4674-4222-0 (ePub)<br/><span class="sc">eisbn</span> 978-1-4674-4188-9 (Kindle)<br/>1. Theology — Study and teaching — United States.<br/>2. Evangelicalism — United States. 3. Mouw, Richard J.<br/>4. Theologians. I. Title.<br/><br/>BV4030.M68 2014<br/>230<span class="symbol">′</span>.046240973 — dc23<br/>                 2014033463</p>
<p class="URL"><a href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Mouw_Called_to_the_Life_of_the_Mind_text_CC1.vue?354d35bf